import React, { useCallback, useState } from 'react';
import { observer } from 'mobx-react';
import { Box, Fade } from '@material-ui/core';
import { FsComponentSize } from 'globals/types';
import { isSuccessState } from 'globals/utils';
import FsTileTabs from 'ui-elements/tabs/FsTileTabs';
import { ActiveTab } from 'ui-elements/tabs/FsTileTabs/FsTileTabs';
import FsPaper from 'ui-elements/main-elements/FsPaper';
import FsLineToggleChart from 'ui-elements/charts/FsLineToggleChart';
import { useReportContext } from 'contexts/report/ReportContext';
import FsDefaultFallbackComponent from 'ui-elements/loaders/FsDefaultFallbackComponent';
import FsGridContainer from 'ui-elements/grid/FsGridContainer/FsGridContainer';
import FsGridItem from 'ui-elements/grid/FsGridItem/FsGridItem';
import { populateTabsData } from './ReportCashflowChartsSection.utils';
import {
  // AddButton,
  ChartContainerBox,
  UpperContainerBox,
} from './ReportCashflowChartsSection.style-elements';

const ReportCashflowChartsSection: React.FC = () => {
  const {
    report: {
      cashflowCharts: { status, tabs, chartData, minMax },
    },
  } = useReportContext();
  const populatedTabs = populateTabsData(tabs());
  const [activeTabs, setActiveTabs] = useState<ActiveTab[]>([]);
  const updateHandler = useCallback((newActiveTabs: ActiveTab[]): void => {
    setActiveTabs(newActiveTabs);
  }, []);
  const activeTabsIdxs = activeTabs.map(({ idx }) => idx);

  if (!isSuccessState(status))
    return (
      <FsDefaultFallbackComponent
        status={status}
        data-test="default-fallback-component"
      />
    );
  return (
    <Fade in={isSuccessState(status)} timeout={1000}>
      <FsGridContainer>
        <FsGridItem xs={12}>
          <FsPaper
            withContentMargin={false}
            paddingSize={FsComponentSize.XS}
            data-test="report-cashflow-charts-section"
          >
            <UpperContainerBox>
              <FsTileTabs tabs={populatedTabs} onUpdate={updateHandler} />
              {/* <AddButton /> */}
            </UpperContainerBox>
            <ChartContainerBox>
              <Box minWidth={800} padding={1}>
                <FsLineToggleChart
                  activeTabsIdxs={activeTabsIdxs}
                  chartData={chartData()}
                  minMax={minMax()}
                  populatedTabs={populatedTabs}
                />
              </Box>
            </ChartContainerBox>
          </FsPaper>
        </FsGridItem>
      </FsGridContainer>
    </Fade>
  );
};

export default observer(ReportCashflowChartsSection);
